import axios from 'axios';

// const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
// const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
const CLOUD_NAME = 'djm7lrihj';
const UPLOAD_PRESET = 'document_thumbnails';

const UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;

/**
 * Uploads a base64 PNG data URL or File to Cloudinary and returns the secure URL.
 * @param {string|File} image - base64 PNG data URL string or a File object
 * @returns {Promise<string>} The secure URL of the uploaded image
 */
export async function uploadToCloudinary(image) {
  if (!CLOUD_NAME || !UPLOAD_PRESET) {
    throw new Error('Cloudinary configuration missing.');
  }

  const formData = new FormData();
  formData.append('upload_preset', UPLOAD_PRESET);
  formData.append('file', image);

  const res = await axios.post(UPLOAD_URL, formData);
  return res.data.secure_url;
}
